import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const PREFIX = 'styles';

const classes = {
  mainContainer: `${PREFIX}-mainContainer`,
};

export const useWaterfallCalculatorStyles = makeStyles<ITheme>(() => ({
  [`& .${classes.mainContainer}`]: {
    width: '100%',
    minWidth: 'fit-content',
  },
}));

export const useNumberFormattedFiedStyles = makeStyles<ITheme>(() => ({
  // Right-aligned "EXIT EQUITY VALUE [$...]" row above the table (redesign).
  equityValueInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 12,
    marginBottom: 12,
  },
  equityValueLabel: {
    color: '#6B7280',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  equityValueField: {
    width: 170,
    '& .MuiOutlinedInput-input': {
      color: '#1774D1',
      fontWeight: 600,
      textAlign: 'right',
      padding: '8px 12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1774D1',
    },
  },
}));
